import { Controller } from "@hotwired/stimulus";

// This controller is created for solve this open issue: https://github.com/spohlenz/tinymce-rails/issues/308
export default class extends Controller {
  static values = { config: Object, mediaImages: Boolean };

  connect() {
    const textarea =
      this.element.querySelector("textarea.tinymce") ||
      this.element.querySelector("textarea");
    if (!textarea) return;

    // Ensure textarea has an ID for TinyMCE
    if (!textarea.id) {
      textarea.id = `tinymce-${Math.random().toString(36).substring(2, 9)}`;
    }

    // Remove existing instance if any before re-initializing
    if (tinymce.get(textarea.id)) {
      tinymce.get(textarea.id).remove();
    }

    const { setup: configSetup, ...restConfig } = this.configValue;
    const mediaImagesConfig = this.mediaImagesValue
      ? this.mediaImagesUploadConfig(textarea.id)
      : {};

    tinymce.init({
      target: textarea,
      ...restConfig,
      ...mediaImagesConfig,
      setup: editor => {
        editor.on("change", () => {
          editor.save();
        });

        if (typeof configSetup === "function") {
          configSetup(editor);
        }
      },
    });
  }

  mediaImagesUploadConfig(textareaId) {
    return {
      relative_urls: false,
      remove_script_host: false,
      automatic_uploads: true,
      paste_data_images: true,
      images_file_types: "jpeg,jpg,png",
      images_upload_handler: (blobInfo, progress) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append(
            "media_image[media]",
            blobInfo.blob(),
            blobInfo.filename()
          );

          const xhr = new XMLHttpRequest();
          xhr.open("POST", Routes.media_images_path({ format: "json" }));
          xhr.setRequestHeader("X-CSRF-TOKEN", window.compliance.token);

          xhr.upload.onprogress = event => {
            if (event.lengthComputable) {
              progress((event.loaded / event.total) * 100);
            }
          };

          xhr.onload = () => {
            if (xhr.status === 201) {
              const data = JSON.parse(xhr.responseText);
              resolve(data.preview_url);
              return;
            }

            const errorMessage = this.parseUploadErrorResponse(xhr);
            const editor = tinymce.get(textareaId);
            this.showUploadError(editor, errorMessage);
            reject(errorMessage);
          };

          xhr.onerror = () => {
            const errorMessage = "Error de red al subir la imagen";
            const editor = tinymce.get(textareaId);
            this.showUploadError(editor, errorMessage);
            reject(errorMessage);
          };

          xhr.send(formData);
        }),
    };
  }

  parseUploadErrorResponse(xhr) {
    try {
      const data = JSON.parse(xhr.responseText);

      if (typeof data === "string" && data.trim().length > 0) {
        return data;
      }

      if (data && typeof data === "object") {
        const messages = Object.values(data)
          .flat()
          .filter(message => typeof message === "string" && message.trim().length > 0);

        if (messages.length > 0) {
          return messages.join(". ");
        }

        if (typeof data.error === "string" && data.error.trim().length > 0) {
          return data.error;
        }

        if (typeof data.message === "string" && data.message.trim().length > 0) {
          return data.message;
        }
      }
    } catch (_error) {
      // Respuesta no JSON (p. ej. página de error HTML)
    }

    return `Error al subir la imagen (${xhr.status})`;
  }

  showUploadError(editor, message) {
    if (!editor?.notificationManager) return;

    editor.notificationManager.open({
      text: message,
      type: "error",
      timeout: 8000,
    });
  }

  disconnect() {
    const textarea =
      this.element.querySelector("textarea.tinymce") ||
      this.element.querySelector("textarea");
    if (textarea && textarea.id && tinymce.get(textarea.id)) {
      tinymce.get(textarea.id).remove();
    }
  }
}
